import { RouterNavigatedAction } from '@ngrx/router-store';
import { createAction, union, props } from '@ngrx/store';

import { SeatMapActions, ServicesActions, OrderActions } from '@fcom/common-booking/store';

import { MmbError, MmbStage } from '../../enums';

export const setLoading = createAction('[MMB State] setLoading', props<{ loading: boolean }>());
export const setError = createAction('[MMB State] setError', props<{ error: MmbError }>());
export const clearError = createAction('[MMB State] clearError');
export const setStage = createAction('[MMB State] setStage', props<{ stage: MmbStage; fromCheckIn?: boolean }>());
export const syncStage = createAction('[MMB State] syncStage', props<{ stage: MmbStage }>());
export const clearStatusState = createAction('[MMB Booking] clearStatusState');
export const setExternalPaymentFlow = createAction(
  '[MMB State] setExternalPaymentFlow',
  props<{ isExternal: boolean }>()
);

const _all = union({
  setLoading,
  setError,
  clearError,
  setStage,
  syncStage,
  clearStatusState,
  setExternalPaymentFlow,
  setSeatForFlight: SeatMapActions.setSeatForFlight,
  clearCategoryUpdating: OrderActions.clearCategoryUpdating,
  resetCategoriesUpdating: OrderActions.resetCategoriesUpdating,
  setSelectionsForFragment: ServicesActions.setSelectionsForFragment,
  setSelectionForFragmentForTraveler: ServicesActions.setSelectionForFragmentForTraveler,
});

export type StateActionsUnion = typeof _all | RouterNavigatedAction;
